import React, { useEffect } from 'react'

import api from 'src/api'
import { PenaltyScheme } from 'src/api/gen/api'
import useSafeState from 'src/commons/hooks/useSafeState'
import Loader from 'src/layout/Loader'

import FeeSchemeEditor from './Editor'
import FeeSummaryPageList from './FeeSummaryPageList'

function FeesSchemePage() {
  const [fees_scheme, setFeesScheme] = useSafeState<PenaltyScheme | null | undefined>(undefined)

  const fetchAndSetSchemeAndPolicies = async function (signal: AbortSignal) {
    try {
      const scheme = await api.penaltySchemes.penaltySchemesList({ is_fee_rates: true, options: { signal } })
      setFeesScheme(scheme)
    } catch (exception: any) {
      if (exception.status == 404) {
        setFeesScheme(null)
      }
    }
  }

  async function archiveScheme() {
    if (fees_scheme) {
      await api.penaltySchemes.penaltySchemesDelete({ id: fees_scheme.id! })
      setFeesScheme(null)
    }
  }

  useEffect(() => {
    const abortController = new AbortController()
    fetchAndSetSchemeAndPolicies(abortController.signal)
    return () => abortController.abort()
  }, [])

  if (fees_scheme === undefined) {
    return <Loader />
  }

  if (fees_scheme === null) {
    return <FeeSchemeEditor setPenaltyScheme={setFeesScheme} />
  }

  return <FeeSummaryPageList fees_scheme={fees_scheme} archiveScheme={archiveScheme} />
}

export default FeesSchemePage
